export async function getTutorialStatus() {
    try {
        const response = await fetch('/tutorial-status', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
            },
            credentials: 'same-origin'
        });
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const data = await response.json();
        return (data.seen_tutorial); // Return the seen_tutorial value
    } catch (error) {
        return error; // Return false in case of an error
    }
}

export async function markTutorialAsSeen() {
    try {
        const response = await fetch('/tutorial-seen', {
            method: 'POST',
            headers: {
                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                'Content-Type': 'application/json'
            },
            credentials: 'same-origin',
        });

        if (!response.ok) {
            throw new Error("Failed to update tutorial status.");
        }
        const data = await response.json();
        return data.seen_tutorial;
    } catch (error) {
        console.error("Error updating tutorial status:", error);
        return null;
    }
}

export async function fillCardForm() {
    try {
        const response = await fetch('/get-simulated-card');
        const simulatedCard = await response.json();

        Object.keys(simulatedCard).forEach((key) => {
            const input = document.querySelector(`[name="${key}"]`);
            if (input) {
                input.value = simulatedCard[key];
            }
        });
    } catch (error) {
        console.error('Error pre-filling form:', error);
    }
}

